exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".carrot-down-black-1 {\n    fill:black;\n}\n\n\n@media only screen and (max-width: 400px) {\n#Chevron_Right {\nmargin-left: 1rem;\n}\n}\n", ""]);
